import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '../app/App'
import '../styles/application.css'

// Tras un deploy, los chunks viejos ya no existen en el servidor. Si el
// navegador tiene una versión vieja de la app abierta e intenta cargar uno
// de forma perezosa (rutas con `lazy`), Vite emite este evento en vez de
// tirar un error sin manejar. Recargamos una sola vez para traer el HTML
// nuevo con las referencias correctas.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  const key = 'vite-preload-reload'
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.reload()
})

const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Si llegamos hasta acá es porque el HTML actual sí tenía chunks válidos:
// soltamos el candado para que un futuro deploy pueda volver a recargar.
sessionStorage.removeItem('vite-preload-reload')
